import VendorSearch from "../Input/VendorSearch";
import React from "react";

const SelectVendor = ({formik, name, label, setSelectedVendor}) => {

    const {handleChange, errors, touched} = formik;

    return <div className={"sl-flex sl-flex-col sl-gap-2"}>
        <span
            className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 "
        >{label}</span>
        <VendorSearch
            hasError={touched[name] && !!errors[name]}
            isAdmin={true}
            onVendorSelect={(vendor) => {
                handleChange({
                    target: {name: name, value: vendor.id}
                })
                setSelectedVendor(vendor);
            }}/>
        {touched[name] &&
        <span
            className="sl-text-error-500 sl-font sl-text-sm sl-font">{errors[name]}</span>}
    </div>
};

export default SelectVendor;